export default {"src":"/_next/static/image/public/images/ic_warning_yellow.46bb3014698745d2d637d353cf5f0085.svg","height":22,"width":22};